import { FC, Fragment, ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import WelcomeScreen from 'src/content/pages/Auth/Register/welcome.screen';
import LoginCover from 'src/content/pages/Auth/Login/Cover';
import { UsePermission } from '../PermissionWrapper';
import { PermissionKey } from 'src/models/user';
import { Language } from 'src/content/dashboards/reports/report/ReportTranslationDropdown/types';
import { useTranslation } from 'react-i18next';
import NotAuthenticatedTranslationLayout from '../NotAuthenticatedTranslationLayout';
import RegisterVerification from 'src/content/pages/Auth/Register/verification/RegisterVerificationJWT';
interface AuthenticatedProps {
  children: ReactNode;
}

const Authenticated: FC<AuthenticatedProps> = (props: { children: any }) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );
  const { hasPermission } = UsePermission();

  const allowToAccessDashboard = hasPermission(
    PermissionKey.ACCESS_DASHBOARD_WITHOUT_SUBSCRIPTION
  );
  // console.log('allowToAccessDashboardallowToAccessDashboard', allowToAccessDashboard, auth?.user)
  const [shouldSubscribe] = useState(
    auth.isAuthenticated && !allowToAccessDashboard
  );

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    return (
      <NotAuthenticatedTranslationLayout>
        <LoginCover />
      </NotAuthenticatedTranslationLayout>
    );
  }

  // Check if the user has a client with an id (needs company registration)
  if (
    auth.isAuthenticated &&
    auth.user && // Make sure user object exists
    (!auth.user.client || !auth.user.client.id) &&
    !location.pathname.includes('/company-registration') &&
    !location.pathname.includes('/login')
  ) {
    console.log(
      'User authenticated but missing client, redirecting to company registration',
      {
        currentPath: location.pathname,
        hasClient: !!auth.user?.client,
        clientId: auth.user?.client?.id
      }
    );

    // Force redirect to company registration
    window.location.href = '/company-registration';
    return null;
  }

  if (auth.isAuthenticated && shouldSubscribe && !auth.user?.client?.name) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return (
      <NotAuthenticatedTranslationLayout>
        <RegisterVerification />
      </NotAuthenticatedTranslationLayout>
    );
  }

  if (shouldSubscribe && !auth.user?.client?.clientSubscription) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

Authenticated.propTypes = {
  children: PropTypes.node
};

export default Authenticated;
